import PopularCategoriesContainer from './PopularCategoriesContainer';

export default PopularCategoriesContainer;
